export const cluster = {
    clusterDiscription:
        "The selected theme's analysis result is displayed in the form of technology clusters by value chain to which the companies belong.\nBy selecting a bubble of a cluster, you can view the details from the lower part of the screen.",
    title: 'Cluster',
    tooltip:
        'For the technology cluster specified in the UI, the evaluation result is shown on the axis of innovation evaluation and Market Expectation. Based on the evaluation results of the technology cluster, users can initially evaluate strategic options. For example, a technology cluster (development theme) with high Market Expectation but a low relative innovation evaluation should be invested in technology (IP) development, centering on startups with a high innovation evaluation in the technology cluster. You can consider the alliance as. On the other hand, for technology clusters (development themes) that have a high evaluation of relative innovation (intellectual strength) but low Market Expectation, business development (for the purpose of improving business efficiency through manufacturing and sales efficiency or data integration) You should invest, and you can consider alliances centered on operating companies that have a high reputation for innovation in the technology cluster.',
    tableIPC: 'Technology Classification',
    tableTitle: 'Main Technology Classification Label',
    tableRate: 'Factor Load Quantity (Contribution to the Cluster)',
    tableCount: 'Number of Patent Application',
    chartTitle1: 'Strategic Options (Selection of Alliance Strategy)',
    chartTitle2: 'Strength / Weakness Analysis',
    tableTitleName: 'Contents of Selected Cluster',
    selectedCompanyIncluded: 'Selected Company Included',
    selectedCompanyExcluded: 'Selected Company Excluded',
    selectedCompanyWithLabel: 'Selected Company With Label',

    chartsTitle: 'Overall Technology Trends',
    clusterSelectMode: 'Cluster Select',
    labelFixMode: 'Label Fix',
    labelClusterId: 'Cluster ID',
    labelClusterName: 'Cluster Name',
    labelPatentCount: 'Patent Count',
    howToReadButton: 'How to read the chart',
    copy: 'Copy',
    download: 'Download',
    aboutTheXAxis: 'About the X-axis settings',
    aboutTheYAxis: 'About the Y-axis settings',
    yAxisUnit: 'bn yen',
    yAxisUnitOfBusinessAmount: 'm USD',
    markPointLabel1: 'Technology Seeds Exploration Domain',
    markPointLabel2: 'Expected Technological Advancement Domain',
    markPointLabel3: 'Technology Trend Domain',
    markPointLabel4: 'Technology Maturing Domain',
    labelAlert: 'Please turn off "Label Fix" when you want to select a cluster',

    clusterHighlight: 'Highlight the cluster.',
    highlightCompany: 'Company',
    highlightPlaceholder: 'Please type in English',
    favoriteCompany: 'Select from favorites',
    companyName: 'Company',
    other: 'Others',

    chart1XAxisScore: 'Score',
    chart1XAxisImpact: 'Impact',
    chart1XAxisStage: 'Stage Information',
    chart1YAxisScale: 'Revenue[k USD]',
    chart1YAxisAmount: 'Minority Investment Amount [m JPY]',

    marketability: 'Market Expectation [m JPY]',
    clusterid: 'Cluster',
    ipcCode: 'Technology Classification',
    ipcMain: 'Main IPC',
    ipcName: 'Technology Classification Label',
    patentcount: 'Number of Patent Application',

    // Cluster Comparison table
    titleClusterComparison: 'Cluster Comparison',
    tblClusterId: 'Cluster ID',
    tblIPCMain: 'Main IPC',
    tblClusterLabel: 'Cluster Label',
    tblScore: 'Score',
    tblScoredeviation: 'Score Deviation Value',
    tblInvestment: 'Minority Investment Amount [m JPY]',
    tblInvestmentdeviation: 'Minority Investment Deviation Value',
    tblWhitespace: 'White Space',
    tblWhitespacedeviation: 'White Space Deviation Value',
    tblRelativeipstrength: 'Relative IP \n Strength',
    tblOverallscore: 'Overall Score',
    // Growing Clusters table
    titleGrowingCluster: 'Growing Cluster',
    GrowingClusterDESC: 'calculated globally with "SELECT a COUNTRY = ALL"',
    tblGrowingClusterName: 'Cluster Label',
    tblGrowingClusterId: 'Cluster Id',
    tblGrowingGrowthRate: 'Growth Rate',
    tblGrowingScore: 'Score',
    tblGrowingMarketability: 'Minority Investment Amount [m JPY]',
    // Cluster's Detail
    // 未使用
    titleClusterDetail: "Cluster's Detail",

    // New table with all the patents IPC
    patentTableTitile: 'Patent List of Selected Cluster (up to the top 100 by Impact)',
    patentRadioTitle: 'Display all the patents in the cluster',
    downloadTitle: 'Download the complete list of the patents',
    tableColumnPublication: 'Publication number',
    tableColumnIPCMain: 'Main IPC',
    tableColumnIPCOther: 'Other IPC',
    tableColumnIPCTitle: 'Title',
    tableColumnOwner: 'Patent Owner',
    tableColumnInventor: 'Inventor',
    tableColumnFLQ: 'Factor Load  Quantity',
    tableColumnImpact: 'Impact',
    tableColumnApplicationYear: 'Application Year',

    // 設定画面
    setting: 'Configuration',
    size: 'Bubble Size',
    yAxisLabel: 'Log scale the y-axis',
    showActualValue: 'Show actual values on axes',
    zoomSlider: 'Zoom Slider',
    nonDisplay: 'Do not fix the labels',
    aboutTheAnalyticalAxis: 'Descriptions of the 4 Domains',
    initButton: 'Revert to Default',

    // 企業一覧作成CSV
    companyCsv: {
        title: 'Create Company List CSV',
        clusterIdTitle: 'Specify Cluster IDs',
        clusterIdPlaceholder: 'Enter cluster IDs',
        clusterIdExample: 'Example: Cluster001, Cluster002, etc.',
        sortTitle: 'Select sort order',
        sortCompanyName: 'Company Name',
        sortBusinessOverview: 'Company Size',
        sortNumberOfEmployees: 'Number of Employees',
        sortAppliedCountry: 'Country',
        sortNumberOfPatents: 'Number of Patent Applications',
        sortImportantPatentsCount: 'Number of Important Patents',
        domainTitle: 'Target Domains',
        domain1: 'Domain 1',
        domain2: 'Domain 2',
        domain3: 'Domain 3',
        domain4: 'Domain 4',
        downloadButton: 'Create Company List CSV',
        downloading: 'Creating Company List CSV...'
    }
}
